<template>
  <div v-if="visible">
    <transition name="fade">
      <div class="modal modal-overlay show d-block" tabindex="-1" role="dialog" @click="close">
        <div class="modal-dialog modal-xl" role="document" @click.stop>
          <div class="modal-content border-0">

            <!-- 標題列 -->
            <div class="modal-header bg-blue-main text-white d-flex justify-content-between align-items-center">
              <div></div>
              <h5 class="modal-title">圖片轉文字</h5>
              <a type="button" class="close text-white" @click="close">
                <span aria-hidden="true">&times;</span>
              </a>
            </div>

            <!-- 步驟進度 -->
            <div class="modal-body">
              <ul class="list-inline text-center mb-4 d-flex justify-content-between">
                <li style="color: gray"
                  v-for="n in 4"
                  :key="n"
                  class="list-inline-item mx-2 flex-1 "
                  :class="{ 'font-weight-bold text-blue-main': step >= n }"
                >
                  <span class="badge badge-pill badge-secondary mr-1">{{ n }}</span>
                  <span class="text-sm">{{ stepLabels[n - 1] }}</span>
                </li>
              </ul>

              <!-- 步驟元件切換 -->
              <component
                :is="currentStepComponent"
                :image-file="imageFile"
                :cropped-image="croppedImage"
                :recognized-text="recognizedText"
                @next="nextStep"
                @prev="step--"
                @finish="submitText"
                @toStepNum="toStep"
              />
            </div>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Step1Upload from './Step1Upload.vue'
import Step2Cropper from './Step2Cropper.vue'
import Step3Ocr from './Step3Ocr.vue'
import Step4Confirm from './Step4Confirm.vue'

export default {
  props: {
    visible: Boolean
  },
  components: {
    Step1Upload,
    Step2Cropper,
    Step3Ocr,
    Step4Confirm
  },
  data () {
    return {
      step: 1,
      imageFile: null,
      croppedImage: null,
      recognizedText: 'As someone who aspires to become However,',
      stepLabels: ['選取與上傳', '裁切圖片', '開始辨識', '辨識修正'],
      stepComponents: [Step1Upload, Step2Cropper, Step3Ocr, Step4Confirm]
    }
  },
  computed: {
    currentStepComponent() {
      return this.stepComponents[this.step - 1]
    }
  },
  methods: {
    nextStep (payload) {
      if (this.step === 1) this.imageFile = payload
      if (this.step === 2) this.croppedImage = payload
      if (this.step === 3) this.recognizedText = payload
      if (this.step < 4) this.step++
    },
    toStep (payload) {
      this.step = payload
      this.imageFile = null
      this.croppedImage = null
      this.recognizedText = ''
    },
    close () {
      this.$emit('update:visible', false)
      this.step = 1
      this.imageFile = null
      this.croppedImage = null
      this.recognizedText = ''
    },
    submitText (payload) {
      this.$emit('submitText', payload)
      this.$emit('update:modelValue', payload)
      this.close()
    }
  }
}
</script>


<style scoped lang="scss">
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
}
.modal-content {
  background: #fff;
  width: 100%;
  // height: 100%;
  max-height: 90vh;
  overflow-y: auto;
  @media (max-width: 769px) {
    max-height: 90vh;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.step-item {
  opacity: 0.5;
  font-weight: bold;
  .stepN {
    background: rgb(0, 0, 0, 0.3);
    color: white;
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
.step-item.active {
  opacity: 1;
  font-weight: bold;
  color: #8c5a42;
  .stepN {
    background: #8c5a42;
    color: white;
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
</style>
